import { ComponentProps, ReactNode } from 'react';
import clsx from 'clsx';

import styles from './FeatureBlock.module.css';

interface FeatureBlockProps extends Omit<ComponentProps<'article'>, 'title' | 'children'> {
  icon: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  cta?: ReactNode;
  children?: never;
}

export default function FeatureBlock({ icon, title, subtitle, cta, className, ...props }: FeatureBlockProps) {
  return (
    <article
      className={clsx(styles.card, className)}
      {...props}
    >
      <div className={styles.head}>
        <div className={styles.iconWrapper}>{icon}</div>

        <div className={styles.content}>
          <div className={styles.title}>{title}</div>
          {subtitle ? <div className={styles.description}>{subtitle}</div> : null}
        </div>
      </div>

      {cta ? <div className={styles.cta}>{cta}</div> : null}
    </article>
  );
}
